// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/fetchResources.js
import { API_URLS } from '../../api/api';

const fetchResources = async (setResources, branchID) => {
  const userID = localStorage.getItem('user_ID');
  const commonHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  };

  try {
    let url = API_URLS.ALL_USERS(userID);
    if (branchID !== 'all') {
      url += `&branch_ID=${branchID}`;
    }

    const response = await fetch(url, {
      headers: commonHeaders,
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }

    const data = await response.json();

    // ตรวจสอบว่า data เป็นอาร์เรย์หรือไม่
    let calendarResources = [];
    if (Array.isArray(data)) {
      calendarResources = data.map((user) => ({
        id: user.user_ID.toString(),
        title: user.first_name || 'Unknown', // Fallback หากไม่มี first_name
      }));
    } else {
      console.warn('API did not return an array:', data);
      // หาก data เป็นอ็อบเจ็กต์เดี่ยว ลองแปลงให้เป็นอาร์เรย์
      if (data && typeof data === 'object' && data.user_ID) {
        calendarResources = [{
          id: data.user_ID.toString(),
          title: data.first_name || 'Unknown'
        }];
      }
    }

    setResources(calendarResources);
  } catch (error) {
    console.error('Error fetching resources:', error);
    setResources([]); // ตั้งค่าเป็นอาร์เรย์ว่างหากล้มเหลว
  }
};

export default fetchResources;